import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

import { CoreInputProps } from './CoreInput';

interface LeadingVisualWrapperProps extends Pick<CoreInputProps, 'disabled'> {}

export const LeadingVisualWrapper = styled.div<LeadingVisualWrapperProps>`
    padding-left: ${theme.space[8]};
    font-weight: ${theme.fontWeights[600]};
    display: flex;
    align-items: center;
    color: ${(props) => (props.disabled ? theme.colors.foreground.disabled : theme.colors.foreground.default)};
`;
